import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vue from 'vue';
import { getUID } from '@/utils';
import { PACKAGE_VERSION } from '@/utils/constant';

class Monitor {
  static dsn = 'https://dacf11b384924ffa86d31089ecbfe3c2@sentry.youthmba.com/4';

  static release = `mobile-marketing_${process.env.VUE_APP_PACK_MODE}@${PACKAGE_VERSION}`;

  static Vue = Vue;


  constructor(options = {}) {
    this.options = options;
  }

  static getInstance(options) {
    if (!(this.instance instanceof this)) {
      this.instance = new this(options);
      this.instance.install();
    }
    return this.instance;
  }

  install() {
    Sentry.init({
      dsn: Monitor.dsn,
      release: Monitor.release,
      environment: this.options.environment,
      integrations: [
        new Integrations.Vue({
          Vue: Monitor.Vue,
          attachProps: true,
        }),
      ],
    });
    Sentry.configureScope((scope) => {
      const id = getUID();
      scope.setUser({ id });
    });
    // 绑定全局监控
    window.Sentry = Sentry;
  }

  log(data = null, type = 'error', message = 'Resource error') {
    if (data instanceof Error) {
      Sentry.captureException(data);
      return;
    }
    Sentry.withScope((scope) => {
      scope.setLevel(type);
      const params = Object.assign(this.options, data);
      scope.setExtra('extra', JSON.stringify(params));
      if (type === 'error') {
        Sentry.captureException(new Error(message));
      } else {
        Sentry.captureMessage(message);
      }
    });
  }
}

export default Monitor;
